import { useNavigate } from 'react-router-dom';
import { Button, Card } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { TreatmentTable } from '../../components/Treatment/TreatmentTable';
import { TitleBreadcrumbs } from '../../uiComponents/TitleBreadcrumbs';
import { useSelector } from 'react-redux';

export const Treatments = () => {
  const {
    privileges: { treatments: privileges = [] },
  } = useSelector((state) => state.userAuth);
  const navigate = useNavigate();

  return (
    <Card title={<TitleBreadcrumbs />} bordered={true} className="gx-card">
      {privileges.includes('create') && (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => {
            navigate('/dashboard/tratamientos/crear');
          }}
        >
          <PlusOutlined />
          Nuevo
        </Button>
      )}
      <TreatmentTable />
    </Card>
  );
};
